import { createFileRoute } from "@tanstack/react-router";
import { restoreSavedChart } from "../services/chart-library";
import { appQueryOptions } from "../services/query-options";
import { pageHead } from "../utils/page-title";

export const Route = createFileRoute("/me")({
  // The current chart session is stored in localStorage rather than a cookie.
  ssr: false,
  loader: async ({ context }) => {
    const data = await context.queryClient.ensureQueryData(appQueryOptions.meChart());
    if (data.ownerChart) restoreSavedChart(data.ownerChart, context.queryClient);
    return data;
  },
  head: () =>
    pageHead("Your Human Design Chart", {
      canonicalPath: "/me",
      robots: "noindex, nofollow",
    }),
});
